/* 🤖 this file was generated by svg-to-ts */
export const matIconSquare: {
  name: 'square';
  data: string;
} = {
  name: 'square',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 3v18h18V3H3zm16 16H5V5h14v14z"/></svg>`
};
